import { useState } from 'react'
import { useRouter } from 'next/router'
import { Row, Col, Form, Input, Button, message, Space } from 'antd'
import styles from '../../styles/login.module.css'
import Consts from '../../configs/consts'
import { withAuth, Type } from '../../providers/auth'
import { UserApi, apiConf } from '../../api'
import Link from 'next/link'
import { validatePassword, passwordPolicyDescription } from '../../utils/password'

const Step = {
  Email: 1,
  NewPassword: 2,
}

function PasswordResetPage({ AuthStore }) {
  const [step, setStep] = useState(Step.Email)
  const router = useRouter()
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState()

  const handleEmail = async (values) => {
    setLoading(true)
    try {
      await UserApi(await apiConf()).userForgotPasswordPost({ email: values.email })
      setEmail(values.email)
      setStep(Step.NewPassword)
    } catch (error) {
      switch (error.json?.code) {
        case 'ForceChangePasswordError':
          message.error('メールで送付している仮パスワードでログインを行なってください。')
          break
        case 'UserNotFoundError':
          setStep(Step.Email)
          break
        case 'LimitExeededError':
          message.error('試行回数の上限に達しました。しばらくしてからもう一度お試しください。')
          break
        default:
          message.error('エラーが発生しました。')
          break
      }
    }
    setLoading(false)
  }

  const handleNewPassword = async (values) => {
    setLoading(true)
    try {
      const { code, password } = values
      await AuthStore.submitResetPassword(email, code, password)
      message.success('パスワードの更新が完了しました')
      router.push('/login')
    } catch (error) {
      message.error(error.message)
      console.warn(error)
    }
    setLoading(false)
  }

  const renderEmailForm = () => {
    return (
      <Form form={form} layout="vertical" requiredMark={false} onFinish={handleEmail}>
        <div className={styles.message}>
          メールアドレスを入力してください。
          <br />
          メールで認証コードを送付します。
        </div>
        <Form.Item name="email" rules={[{ required: true, message: 'メールアドレスを入力してください' }]}>
          <Input type="email" size="large" placeholder="メールアドレス" />
        </Form.Item>
        <Button type="primary" htmlType="submit" size="large" block loading={loading} className={styles.loginButton}>
          認証コードを送信
        </Button>
      </Form>
    )
  }

  const renderNewPasswordForm = () => {
    return (
      <Form form={form} layout="vertical" requiredMark={false} onFinish={handleNewPassword}>
        <div className={styles.message}>
          メールに届いた認証コードと
          <br />
          新しいパスワードを入力してください。
        </div>
        <Form.Item name="code" rules={[{ required: true, message: '認証コードを入力してください' }]}>
          <Input size="large" placeholder="認証コード" />
        </Form.Item>
        <Form.Item
          name="password"
          extra={<span style={{ fontSize: 14 }}>{passwordPolicyDescription()}</span>}
          rules={[
            { required: true, message: '新しいパスワードを入力してください' },
            { validator: validatePassword(), validateTrigger: 'onSubmit' },
          ]}>
          <Input type="password" size="large" placeholder="新しいパスワード" />
        </Form.Item>
        <Button type="primary" htmlType="submit" size="large" block loading={loading} className={styles.loginButton}>
          パスワードを更新
        </Button>
      </Form>
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Row type="flex" justify="center" align="middle">
          <Col xs={24} sm={18} md={14} lg={10} xl={8}>
            <div className={styles.formContainer}>
              <div className={styles.description}>パスワード再設定</div>
              {step === Step.Email ? renderEmailForm() : renderNewPasswordForm()}
            </div>
          </Col>
        </Row>
        <div className={styles.link}>
          <Link href="/login">戻る</Link>
        </div>
      </div>
    </div>
  )
}

export default withAuth(PasswordResetPage, Type.NotProtected)
